import { useMemo } from 'react'

import { KojinResult } from 'interface/kojin'
import { KojinStatisticsBySisetuResult } from './data'

import { Box, BoxProps, Paper } from '@mui/material'

import Grid from '@mui/material/Grid'

import { NenreiHistgram } from './nenreiHistgram'
//import { SinryokaListSection } from './sinryokalist'
import { BukaListSection } from './bukaList'
import { SenmoniListSection } from './senmonilist'
import { SotukouListSection } from './sotukoulist'
import { CollaborateListSection } from './collaborateList'
import { IsikaiGraph } from './isikaiGraph'
import { KaiinGraph } from './kaiinGraph'
import { GakkaiGraph } from './gakkaiGraph'

import { SisetuDoctorsCondition, SisetuDoctorsConditions, SisetuDoctorsConditionsAxis, SisetuDoctorsNenreiCondition, isValid } from '../condition'
import { useUserSession } from 'features/session/context'

type SisetuPreviewDoctorsDashBoardProps = {
  sisetuCode: string
  kojinList?: KojinResult[]
  condition: SisetuDoctorsConditions
  onChangeCondition: (
    axisKey: SisetuDoctorsConditionsAxis,
    condition?: SisetuDoctorsCondition | SisetuDoctorsNenreiCondition
  ) => void
  onSisetuOpen: (sisetuCode: string) => void
} & BoxProps

export const SisetuPreviewDoctorsDashBoard = ({
  sisetuCode,
  kojinList,
  condition,
  onChangeCondition,
  onSisetuOpen,
  ...others
}: SisetuPreviewDoctorsDashBoardProps) => {
  const { isCareNet } = useUserSession()
  const statistics = useMemo<KojinStatisticsBySisetuResult | null>(
    () => {
      if (!kojinList) return null

      const result: KojinStatisticsBySisetuResult = {
        nenrei: [],
        buka: [],
        sinryoka: [],
        sotukou: [],
        gakkai: [],
        senmoni: [],
        isikai: [],
        collabo: [],
        memberClass: [],
      }
      for (const kojin of kojinList) {
        if (
          kojin.nenrei && kojin.seibetuCode &&
          isValid(sisetuCode, condition, kojin, 'nenrei')
        ) {
          let nenrei = result.nenrei.find(
            (r) => r.nenrei === kojin.nenrei && r.seibetuCode === kojin.seibetuCode
          )
          if (!nenrei) {
            nenrei = {
              nenrei: kojin.nenrei,
              seibetuCode: kojin.seibetuCode,
              doctorsCount: 0,
            }
            result.nenrei.push(nenrei)
          }
          nenrei.doctorsCount++
        }
        if (isValid(sisetuCode, condition, kojin, 'buka')) {
          kojin.organ?.forEach(organ => {
            if (organ.sisetuCode && organ.sisetuCode === sisetuCode) {
              const bukaCode = organ.bukaCode ?? 'empty'
              let buka = result.buka.find(buka => buka.bukaCode === bukaCode)
              if (!buka) {
                buka = {
                  bukaCode: bukaCode,
                  bukaName: organ.bukaCode ? (organ.bukaName ?? '') : '(所属なし)',
                  kojinCount: 0
                }
                result.buka.push(buka)
              }
              buka.kojinCount++
            }
          })
        }
        if (isValid(sisetuCode, condition, kojin, 'sinryoka')) {
          kojin.sinryoka?.forEach((s) => {
            if (s.sinryokaCode) {
              let sinryoka = result.sinryoka.find(
                (r) => r.sinryokaCode === s.sinryokaCode
              )
              if (!sinryoka) {
                sinryoka = {
                  sinryokaCode: s.sinryokaCode,
                  sinryokaName: s.sinryokaName ?? '',
                  kojinCount: 0,
                }
                result.sinryoka.push(sinryoka)
              }
              sinryoka.kojinCount++
            }
          })
        }
        if (
          kojin.sotukouCode &&
          isValid(sisetuCode, condition, kojin, 'sotukou')
        ) {
          let sotukou = result.sotukou.find(
            (r) => r.sotukouCode === kojin.sotukouCode
          )
          if (!sotukou) {
            sotukou = {
              sotukouCode: kojin.sotukouCode,
              sotukouName: kojin.sotukouName ?? '',
              sotukouOldName: null,
              sotukouEnglishName: null,
              sotukouRyakuName: null,
              kojinCount: 0,
            }
            result.sotukou.push(sotukou)
          }
          sotukou.kojinCount++
        }
        if (isValid(sisetuCode, condition, kojin, 'gakkai')) {
          kojin.gakkai?.forEach((g) => {
            if (g.gakkaiCode) {
              let gakkai = result.gakkai.find(
                (r) => r.gakkaiCode === g.gakkaiCode
              )
              if (!gakkai) {
                gakkai = {
                  gakkaiCode: g.gakkaiCode,
                  gakkaiName: g.gakkaiName ?? '',
                  kojinCount: 0,
                }
                result.gakkai.push(gakkai)
              }
              gakkai.kojinCount++
            }
          })
        }
        if (isValid(sisetuCode, condition, kojin, 'senmoni')) {
          kojin.senmoni?.forEach((s) => {
            if (s.senmoniCode) {
              let senmoni = result.senmoni.find(
                (r) => r.senmoniCode === s.senmoniCode
              )
              if (!senmoni) {
                senmoni = {
                  senmoniCode: s.senmoniCode,
                  senmoniName: s.senmoniName ?? '',
                  kojinCount: 0,
                  senmonCount: 0,
                  ninteiCount: 0,
                  sidouCount: 0,
                }
                result.senmoni.push(senmoni)
              }
              if (s.ninteii) senmoni.ninteiCount++
              if (s.senmoni) senmoni.senmonCount++
              if (s.sidoui) senmoni.sidouCount++
              senmoni.kojinCount++
            }
          })
        }
        if (
          kojin.isikaiCode &&
          isValid(sisetuCode, condition, kojin, 'isikai')
        ) {
          let isikai = result.isikai.find(
            (r) => r.isikaiCode === kojin.isikaiCode
          )
          if (!isikai) {
            isikai = {
              isikaiCode: kojin.isikaiCode,
              isikaiName: kojin.isikaiName ?? '',
              kojinCount: 0,
            }
            result.isikai.push(isikai)
          }
          isikai.kojinCount++
        }
        if (isValid(sisetuCode, condition, kojin, 'collabo')) {
          kojin.organ?.forEach(organ => {
            if (organ.sisetuCode && organ.sisetuCode !== sisetuCode) {
              let collabo = result.collabo.find(
                collabolator => collabolator.sisetuCode === organ.sisetuCode
              )
              if (!collabo) {
                collabo = {
                  sisetuCode: organ.sisetuCode,
                  sisetuName: organ.sisetuName ?? '',
                  oyaDaigakuCode: null,
                  oyaDaigakuName: null,
                  kojinCount: 0
                }
                result.collabo.push(collabo)
              }
              collabo.kojinCount++
            }
          })
        }
        if (isCareNet && isValid(sisetuCode, condition, kojin, 'memberClass')) {
          const memberClassCode = kojin.personalId ? 'member' : 'none'
          let memberClass = result.memberClass.find(
            r => r.memberClassCode === memberClassCode
          )
          if (!memberClass) {
            memberClass = {
              memberClassCode: memberClassCode,
              memberClassName: { member: '会員', none: '非会員' }[memberClassCode] ?? '',
              kojinCount: 0
            }
            result.memberClass.push(memberClass)
          }
          memberClass.kojinCount++
        }
      }
      return result
    },
    [sisetuCode, kojinList, condition, isCareNet]
  )
  return (
    <Box {...others}>
      <Grid
        container
        //disableEqualOverflow
        padding={1}
        spacing={1}
        columns={{ xs: 3, sm: 6, md: 9, lg: 12 }}
      >
        <Grid size={isCareNet ? 9 : 12}>
          <Paper
            sx={{ height: '12em', overflow: 'hidden', position: 'relative' }}
          >
            <NenreiHistgram
              sisetuCode={sisetuCode}
              dataList={statistics?.nenrei}
              condition={condition}
              onChangeCondition={onChangeCondition}
            />
          </Paper>
        </Grid>

        {isCareNet && (
          <Grid size={3}>
            <Paper
              sx={{ height: '12em', overflow: 'hidden', position: 'relative' }}
            >
              <KaiinGraph
                sisetuCode={sisetuCode}
                dataList={statistics?.memberClass}
                condition={condition}
                onChangeCondition={onChangeCondition}
              />
            </Paper>
          </Grid>
        )}

        <Grid size={3}>
          <Paper
            sx={{ height: '20em', overflow: 'hidden', position: 'relative' }}
          >
            <BukaListSection
              sisetuCode={sisetuCode}
              dataList={statistics?.buka}
              condition={condition}
              onChangeCondition={onChangeCondition}
            />
          </Paper>
        </Grid>

        {/*
        <Grid size={3}>
          <Paper
            sx={{ height: '20em', overflow: 'hidden', position: 'relative' }}
          >
            <SinryokaListSection
              sisetuCode={sisetuCode}
              dataList={statistics?.sinryoka}
              condition={condition}
              onChangeCondition={onChangeCondition}
            />
          </Paper>
        </Grid>
        */}

        <Grid size={3}>
          <Paper
            sx={{ height: '20em', overflow: 'hidden', position: 'relative' }}
          >
            <SenmoniListSection
              sisetuCode={sisetuCode}
              dataList={statistics?.senmoni}
              condition={condition}
              onChangeCondition={onChangeCondition}
            />
          </Paper>
        </Grid>

        <Grid size={3}>
          <Paper
            sx={{ height: '20em', overflow: 'hidden', position: 'relative' }}
          >
            <SotukouListSection
              sisetuCode={sisetuCode}
              dataList={statistics?.sotukou}
              condition={condition}
              onChangeCondition={onChangeCondition}
            />
          </Paper>
        </Grid>

        <Grid size={3}>
          <Paper
            sx={{ height: '20em', overflow: 'hidden', position: 'relative' }}
          >
            <CollaborateListSection
              sisetuCode={sisetuCode}
              dataList={statistics?.collabo}
              condition={condition}
              onChangeCondition={onChangeCondition}
              onSisetuOpen={onSisetuOpen}
            />
          </Paper>
        </Grid>

        <Grid size={3}>
          <Paper
            sx={{ height: '20em', overflow: 'hidden', position: 'relative' }}
          >
            <IsikaiGraph
              sisetuCode={sisetuCode}
              dataList={statistics?.isikai}
              condition={condition}
              onChangeCondition={onChangeCondition}
            />
          </Paper>
        </Grid>

        <Grid size={9}>
          <Paper
            sx={{ height: '20em', overflow: 'hidden', position: 'relative' }}
          >
            <GakkaiGraph
              sisetuCode={sisetuCode}
              dataList={statistics?.gakkai}
              condition={condition}
              onChangeCondition={onChangeCondition}
            />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  )
}
